import React from 'react';
import {styled, ThemeProvider} from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import ExpandMoreIcon from '@svg/expand-more-arrow.svg';
import MuiSelectTheme from '@/themes/mui/MuiSelectTheme.js';
import {COLOR_BLACK} from "@/themes/colors.jsx";

const MUISelect = React.forwardRef(({ options, label, placeholder, disallowUnselect = false ,fullWidth = false, size = null, errorMessage = '', ...props }, ref) => {
    const isValid = !(React.isValidElement(errorMessage) ? !!errorMessage : !!errorMessage?.length);

    if (fullWidth) {
        size = null;
    }

    return (
        <ThemeProvider theme={MuiSelectTheme}>
            <FormControl fullWidth={fullWidth} className={size}>
                {label?.length > 0 && (
                    <InputLabel
                        id={props.name ? `${props.name}-select-label` : null}
                        htmlFor={props.name ? `${props.name}-input` : null}
                        error={!isValid}
                        shrink={true}
                    >
                        {(() => {
                            if (!isValid) {
                                return errorMessage
                            } else {
                                return label
                            }
                        })()}
                    </InputLabel>
                )}

                <Select
                    {...props}
                    IconComponent={ExpandMoreIconStyled}
                    inputRef={ref}
                    labelId={`${props.key}-select-label`}
                    fullWidth
                    displayEmpty={true}
                    onChange={props.onChange}
                    input={
                        <OutlinedInput
                            error={errorMessage?.length > 0}
                        />
                    }
                    renderValue={
                        typeof props.value !== "undefined" && props.value !== null && props.value !== '' && props.value != placeholder?.value ? undefined : () => {
                            return <Placeholder>{placeholder}</Placeholder>
                        }
                    }
                >
                    {placeholder && (
                        <MenuItem key={'placeholder'}
                                  // value={placeholder}
                                  sx={{
                                      opacity: 0.38,
                                  }}
                                  disabled={disallowUnselect}
                                  onClick={() => {
                            if (typeof (props.onOptionClick) == 'function') {
                                props.onOptionClick();
                            }
                        }}>
                            {placeholder}
                        </MenuItem>
                    )}

                    {options.map((item) => {
                        return (
                            <MenuItem key={item.value} value={item.value}
                                      onClick={() => {
                                          if (typeof (props.onOptionClick) == 'function') {
                                              props.onOptionClick();
                                          }
                                      }}>
                                {item.label}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </ThemeProvider>
    );
});

MUISelect.propTypes = {};

export default MUISelect;

const Placeholder = styled('div')({
    color: COLOR_BLACK,
    opacity: '0.3',
});


const ExpandMoreIconStyled = styled(ExpandMoreIcon)({
    marginTop: '3px',
    right: '15px !important',
});
